import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Service from "@/pages/Service";
import Works from "@/pages/Works";
import RealEstate from "@/pages/RealEstate";
import Company from "@/pages/Company";
import Recruit from "@/pages/Recruit";
import Contact from "@/pages/Contact";
import WorkDetail from "@/pages/WorkDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminWorks from "@/pages/admin/AdminWorks";
import AdminRealEstate from "@/pages/admin/AdminRealEstate";
import AdminCompany from "@/pages/admin/AdminCompany";
import AdminMail from "@/pages/admin/AdminMail";
import AdminService from "@/pages/admin/AdminService";
import AdminRecruit from "@/pages/admin/AdminRecruit";
import AdminAbout from "@/pages/admin/AdminAbout";
import AdminHome from "@/pages/admin/AdminHome";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminBankAccounts from "@/pages/admin/AdminBankAccounts";
import { AdminCustomers, AdminPartners } from "@/pages/admin/AdminMasters";
import AdminStaff from "@/pages/admin/AdminStaff";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminSites from "@/pages/admin/AdminSites";
import AdminSchedules from "@/pages/admin/AdminSchedules";
import AdminInstructions from "@/pages/admin/AdminInstructions";
import AdminSitePhotos from "@/pages/admin/AdminSitePhotos";
import AdminWorkTypes from "@/pages/admin/AdminWorkTypes";
import AdminBusinessHome from "@/pages/admin/AdminBusinessHome";
import AdminProjectDetail from "@/pages/admin/AdminProjectDetail";
import AdminEstimates from "@/pages/admin/AdminEstimates";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminWorkflow from "@/pages/admin/AdminWorkflow";
import AdminWorkflowDetail from "@/pages/admin/AdminWorkflowDetail";
import StaffLogin from "@/pages/staff/StaffLogin";
import StaffLayout from "@/pages/staff/StaffLayout";
import StaffHome from "@/pages/staff/StaffHome";
import StaffSchedule from "@/pages/staff/StaffSchedule";
import StaffPhotos from "@/pages/staff/StaffPhotos";
import StaffReport from "@/pages/staff/StaffReport";
import StaffSurvey from "@/pages/staff/StaffSurvey";

function CatchAll() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <Navigate to="/admin/login" replace />;
  if (pathname.startsWith("/staff")) return <Navigate to="/staff/login" replace />;
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/service" element={<Service />} />
            <Route path="/works" element={<Works />} />
            <Route path="/works/:id" element={<WorkDetail />} />
            <Route path="/real-estate" element={<RealEstate />} />
            <Route path="/company" element={<Company />} />
            <Route path="/recruit" element={<Recruit />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="works" element={<AdminWorks />} />
            <Route path="real-estate" element={<AdminRealEstate />} />
            <Route path="company" element={<AdminCompany />} />
            <Route path="mail" element={<AdminMail />} />
            <Route path="services" element={<AdminService />} />
            <Route path="recruit" element={<AdminRecruit />} />
            <Route path="about" element={<AdminAbout />} />
            <Route path="home" element={<AdminHome />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="bank-accounts" element={<AdminBankAccounts />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="staff" element={<AdminStaff />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="sites" element={<AdminSites />} />
            <Route path="schedules" element={<AdminSchedules />} />
            <Route path="instructions" element={<AdminInstructions />} />
            <Route path="site-photos" element={<AdminSitePhotos />} />
            <Route path="work-types" element={<AdminWorkTypes />} />
            <Route path="business" element={<AdminBusinessHome />} />
            <Route path="workflow" element={<AdminWorkflow />} />
            <Route path="workflow/:projectId" element={<AdminWorkflowDetail />} />
            <Route path="estimates" element={<AdminEstimates />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="projects/:projectId" element={<AdminProjectDetail />} />
          </Route>
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff" element={<StaffLayout />}>
            <Route index element={<StaffHome />} />
            <Route path="schedule" element={<StaffSchedule />} />
            <Route path="photos" element={<StaffPhotos />} />
            <Route path="report" element={<StaffReport />} />
            <Route path="survey" element={<StaffSurvey />} />
          </Route>
          <Route path="*" element={<CatchAll />} />
        </Routes>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
